import AvailableWidget from './AvailableWidget';
import Customer from './Customer';
import ReportTemplate from './ReportTemplate';
import Tag from './Tag';
import Widget from './Widget';

export { 
    AvailableWidget, 
    Customer,
    ReportTemplate,
    Tag,
    Widget,
};


// WEBPACK FOOTER //
// ./src/store/models/index.ts